export default {
  overrideRequest: function (axiosConfig) {

  },

  refreshtoken: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.refreshToken = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/Tokens.js